module.exports = __webpack_public_path__ + "img/Image_logo_3.1723c534.jpg";